import { render, staticRenderFns } from "./AdditionalAddressModal.vue?vue&type=template&id=e2125db8&scoped=true"
import script from "./AdditionalAddressModal.vue?vue&type=script&lang=js"
export * from "./AdditionalAddressModal.vue?vue&type=script&lang=js"
import style0 from "./AdditionalAddressModal.vue?vue&type=style&index=0&id=e2125db8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2125db8",
  null
  
)

export default component.exports